import { render, staticRenderFns } from "./readjustment.component.vue?vue&type=template&id=156baf1d&scoped=true&"
import script from "./readjustment.component.vue?vue&type=script&lang=ts&"
export * from "./readjustment.component.vue?vue&type=script&lang=ts&"
import style0 from "./readjustment.component.vue?vue&type=style&index=0&id=156baf1d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156baf1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCheckbox,VDivider,VRadio,VRadioGroup,VSpacer})
